import TextDataTransformerBlock, {
    TextDataTransformerBlockProps,
} from '@activebrands/core-web/libs/storyblok/content/CmsDataTransformerBlock/TextDataTransformerBlock';
import { ModuleContentSection } from '@activebrands/core-web/components/modules/ModuleSection';
import { BaseModuleProps } from '@activebrands/core-web/types/modules';

interface TextModuleProps extends BaseModuleProps, TextDataTransformerBlockProps {}

const TextModule = ({ isGrid = false, content, isFullWidth, isThreeColumns, isTwoColumns }: TextModuleProps) => {
    return (
        <ModuleContentSection $isGrid={isGrid}>
            <TextDataTransformerBlock
                content={content}
                isFullWidth={isFullWidth}
                isThreeColumns={isThreeColumns}
                isTwoColumns={isTwoColumns}
            />
        </ModuleContentSection>
    );
};

export default TextModule;
